import { apiRequest } from "@nusrif/utils";
import { ApiResponse, AddPushTokenInput } from "@nusrif/types";

/**
 * Add a push token for a user.
 * @param input - The input data for adding the push token.
 * @returns A promise that resolves to the API response.
 */
export async function addPushToken(input: AddPushTokenInput): Promise<ApiResponse<null>> {
    return apiRequest<ApiResponse<null>>('/push-tokens', {
        method: 'POST',
        body: input,
    });
}